import {
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_BEGIN,
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_SUCCESS,
  COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_FAILURE
} from '../constants'
import { BFFAgent } from 'BFFAgent'

export function reducer(state, action) {
  switch (action.type) {
    case COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_BEGIN:
      return {
        ...state,
        policies: {
          ...state.policies,
          getPossibleActionsSuccess: false
        }
      }
    case COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_SUCCESS:
      const commissionPolicyPossibleActionsArray = BFFAgent.Commission.mapPossibleActionToOptions(action.data)
      return {
        ...state,
        policies: {
          ...state.policies,
          commissionPolicyPossibleActions: commissionPolicyPossibleActionsArray,
          getPossibleActionsSuccess:true
        }
      }
    case COMMISSION_POLICY_GET_POSSIBLE_ACTIONS_FAILURE:
      return {
        ...state,
        policies: {
          ...state.policies, 
        }
      }
    default:
      return state
  }
}
